const peixunData = {
  '1': {
    教学目的: [
      {
        title: '【教学目的】打标签.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E6%89%93%E6%A0%87%E7%AD%BE.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】如何打标签.mp4',
        type: 'video',
        url: 'https://vod.aconsulting.top/sv/18d7ba09-1751b2f1453/18d7ba09-1751b2f1453.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】打标签.pdf',
        type: 'pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%89%93%E6%A0%87%E7%AD%BE.pdf',
      },
      {
        title: '人才详情功能使用教程',
        type: 'word',
        md5: '3cd9cfa237f5980d82966cdbf86d024a',
      },
    ],
  },
  '2': {
    视频: [
      {
        title: '【教学视频】项目详情.mp4',
        url: 'https://vod.aconsulting.top/sv/7653c0e-1751b2f1453/7653c0e-1751b2f1453.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】项目详情分析.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%A1%B9%E7%9B%AE%E8%AF%A6%E6%83%85%E5%88%86%E6%9E%90.pdf',
      },
      {
        title: '【示例】项目分析-医药基金经理.docx',
        type: 'word',
        md5: '6adf9b5d8ee18df70ab61760effd7f65',
      },
      {
        title: '核心要求分析.png',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E6%A0%B8%E5%BF%83%E8%A6%81%E6%B1%82%E5%88%86%E6%9E%90.png',
      },
      {
        title: '确定寻访方向.png',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E7%A1%AE%E5%AE%9A%E5%AF%BB%E8%AE%BF%E6%96%B9%E5%90%91.png',
      },
      {
        title: '职位分析.png',
        type: 'img',
        url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E8%81%8C%E4%BD%8D%E5%88%86%E6%9E%90.png',
      },
      {
        title: '项目详情功能使用教程',
        type: 'word',
        md5: '093cfaaf50ae87b9a841adf5b1a7677a',
      },
      {
        title: '职位亮点及风险点分析.png',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E8%81%8C%E4%BD%8D%E4%BA%AE%E7%82%B9%E5%8F%8A%E9%A3%8E%E9%99%A9%E7%82%B9%E5%88%86%E6%9E%90.png',
      },
      {
        title: 'BD阶段-客户对接操作手册之项目管理阶段',
        type: 'word',
        md5: '465a47b08ce30c52d0afc09f95f71a38',
      },
    ],
  },
  '3': {
    教学目的: [
      {
        title: '【教学目的】如何克服打电话的心理障碍.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E5%A6%82%E4%BD%95%E5%85%8B%E6%9C%8D%E6%89%93%E7%94%B5%E8%AF%9D%E7%9A%84%E5%BF%83%E7%90%86%E9%9A%9C%E7%A2%8D.jpg',
      },
      {
        title: '【教学目的】深度把握人选意向和诉求.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E6%B7%B1%E5%BA%A6%E6%8A%8A%E6%8F%A1%E4%BA%BA%E9%80%89%E6%84%8F%E5%90%91%E5%92%8C%E8%AF%89%E6%B1%82.jpg',
      },
      {
        title: '【教学目的】要简历.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E8%A6%81%E7%AE%80%E5%8E%86.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】如何克服打电话的心理障碍.mp4',
        url: 'https://vod.aconsulting.top/sv/2f25142e-1751ad17575/2f25142e-1751ad17575.mp4',
      },
      {
        title: '【教学视频】打电话.mp4',
        url: 'https://vod.aconsulting.top/sv/bef072c-1751acd7804/bef072c-1751acd7804.mp4',
      },
      {
        title: '【教学视频】深度把握人选意向和诉求.mp4',
        url: 'https://vod.aconsulting.top/sv/5c8dbd29-1751b2f1466/5c8dbd29-1751b2f1466.mp4',
      },
      {
        title: '【教学视频】要简历.mp4',
        url: 'https://vod.aconsulting.top/sv/16d00378-1751b3d91e8/16d00378-1751b3d91e8.mp4',
      },
    ],
    音频: [
      {
        title: '【场景语音】雪哥第一通电话-短电话1.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%9C%BA%E6%99%AF%E8%AF%AD%E9%9F%B3%E3%80%91%E9%9B%AA%E5%93%A5%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D-%E7%9F%AD%E7%94%B5%E8%AF%9D1.mp3',
      },
      {
        title: '【场景语音】雪哥第一通电话-短电话2.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%9C%BA%E6%99%AF%E8%AF%AD%E9%9F%B3%E3%80%91%E9%9B%AA%E5%93%A5%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D-%E7%9F%AD%E7%94%B5%E8%AF%9D2.mp3',
      },
      {
        title: '【场景语音】雪哥第一通电话-短电话3.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%9C%BA%E6%99%AF%E8%AF%AD%E9%9F%B3%E3%80%91%E9%9B%AA%E5%93%A5%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D-%E7%9F%AD%E7%94%B5%E8%AF%9D3.mp3',
      },
    ],
    附件: [
      {
        title: '【操作手册】第一通电话.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D.pdf',
      },
      {
        title: '【操作手册】如何克服打电话的心理障碍.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E5%A6%82%E4%BD%95%E5%85%8B%E6%9C%8D%E6%89%93%E7%94%B5%E8%AF%9D%E7%9A%84%E5%BF%83%E7%90%86%E9%9A%9C%E7%A2%8D.pdf',
      },
      {
        title: '【操作手册】深度把握人选意向和诉求.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%B7%B1%E5%BA%A6%E6%8A%8A%E6%8F%A1%E4%BA%BA%E9%80%89%E6%84%8F%E5%90%91%E5%92%8C%E8%AF%89%E6%B1%82.pdf',
      },
      {
        title: '【操作手册】要简历.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E8%A6%81%E7%AE%80%E5%8E%86.pdf',
      },
      {
        title: '【操作导图】日常电话流程图.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%9B%BE%E3%80%91%E6%97%A5%E5%B8%B8%E7%94%B5%E8%AF%9D%E6%B5%81%E7%A8%8B%E5%9B%BE.pdf',
      },
      {
        title: '【模版】第一通电话话术.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%A8%A1%E6%9D%BF%E3%80%91%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D%E8%AF%9D%E6%9C%AF.pdf',
      },
      {
        title: '【沟通备注】高兴',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%B2%9F%E9%80%9A%E5%A4%87%E6%B3%A8%E3%80%91%E9%AB%98%E5%85%B4.jpg',
      },
      {
        title: '【沟通备注】申佰畅',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%B2%9F%E9%80%9A%E5%A4%87%E6%B3%A8%E3%80%91%E7%94%B3%E4%BD%B0%E7%95%85.png',
      },
      {
        title: '小乔沟通备注',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%B0%8F%E4%B9%94%E6%B2%9F%E9%80%9A%E5%A4%87%E6%B3%A84.png',
      },
    ],
  },
  '4': {
    教学目的: [
      {
        title: '【教学目的】如何帮助大佬写简历.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E5%A6%82%E4%BD%95%E5%B8%AE%E5%8A%A9%E5%A4%A7%E4%BD%AC%E5%86%99%E7%AE%80%E5%8E%86.jpg',
      },
      {
        title: '【教学目的】推荐报告的制作.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E6%8E%A8%E8%8D%90%E6%8A%A5%E5%91%8A%E7%9A%84%E5%88%B6%E4%BD%9C.jpg',
      },
      {
        title: '【教学目的】推荐邮件的撰写和发送.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E6%8E%A8%E8%8D%90%E9%82%AE%E4%BB%B6%E7%9A%84%E6%92%B0%E5%86%99%E5%92%8C%E5%8F%91%E9%80%81.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】如何帮大佬写简历.mp4',
        url: 'https://vod.aconsulting.top/sv/8c6e169-1751b2f1491/8c6e169-1751b2f1491.mp4',
      },
      {
        title: '【教学视频】如何撰写与发送推荐邮件.mp4',
        url: 'https://vod.aconsulting.top/sv/23059c15-1751b490fba/23059c15-1751b490fba.mp4',
      },
      {
        title: '【教学视频】推荐报告的制作.mp4',
        url: 'https://vod.aconsulting.top/sv/4b562077-1751b481606/4b562077-1751b481606.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】如何帮助大佬写简历.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E5%A6%82%E4%BD%95%E5%B8%AE%E5%8A%A9%E5%A4%A7%E4%BD%AC%E5%86%99%E7%AE%80%E5%8E%86.pdf',
      },
      {
        title: '【操作手册】推荐报告的制作.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%8E%A8%E8%8D%90%E6%8A%A5%E5%91%8A%E7%9A%84%E5%88%B6%E4%BD%9C.pdf',
      },
      {
        title: '【操作手册】推荐邮件的撰写和发送.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%8E%A8%E8%8D%90%E9%82%AE%E4%BB%B6%E7%9A%84%E6%92%B0%E5%86%99%E5%92%8C%E5%8F%91%E9%80%81.pdf',
      },
      {
        title: '【范例】李先生-XX公司-XX岗-阿尔法咨询.docx',
        type: 'word',
        md5: '17a3bcdbea8f89a14e74db085bd477ee',
      },
      {
        title: '【模版】推荐邮件的撰写和发送.docx',
        type: 'word',
        md5: '04b3f871b12bd8b5c704a7dec816ff4a',
      },
      {
        title: '【推荐报告】高兴',
        type: 'word',
        md5: '29eb51503ea83ea2696eab40bc9767bf',
      },
      {
        title: '【推荐报告】高兴2',
        type: 'word',
        md5: 'ee3c1530a4bbfdc7fe9dfc32c75261e3',
      },
      {
        title: '【推荐报告】通灵',
        type: 'word',
        md5: '18f93ab6bf6828c4f7de0a21f2c617a7',
      },
      {
        title: '【推荐报告】Eric',
        type: 'word',
        md5: '8153da3cf8ef9123cb59fd4603b01e9b',
      },
    ],
  },
  '5': {
    教学目的: [
      {
        title: '【教学目的】人选会面.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E4%BA%BA%E9%80%89%E4%BC%9A%E9%9D%A2.jpg',
      },
      {
        title: '【教学目的】背景调查.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E8%83%8C%E6%99%AF%E8%B0%83%E6%9F%A5.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】人选会面.mp4',
        url: 'https://vod.aconsulting.top/sv/1c8911ef-1751c44346e/1c8911ef-1751c44346e.mp4',
      },
      {
        title: '【视频教学】背景调查.mp4',
        url: 'https://vod.aconsulting.top/sv/428f6b1b-1751fc7c503/428f6b1b-1751fc7c503.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】人选会面.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E4%BA%BA%E9%80%89%E4%BC%9A%E9%9D%A2.pdf',
      },
      {
        title: '【操作导图】人选会面流程.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%9B%BE%E3%80%91%E4%BA%BA%E9%80%89%E4%BC%9A%E9%9D%A2%E6%B5%81%E7%A8%8B.jpg',
      },
      {
        title: '【范例】会面记录-华兴HR-薪酬激励.docx',
        type: 'word',
        md5: 'bf87ce96775303993e5247f1b57fc311',
      },
      {
        title: '【模版】人选会面记录.docx',
        type: 'word',
        md5: '2967f3c0e128ee9ef5121116ac24924b',
      },
      {
        title: '【操作手册】背景调查.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E8%83%8C%E6%99%AF%E8%B0%83%E6%9F%A5.pdf',
      },
      {
        title: '【口碑】通灵',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%8F%A3%E7%A2%91%E3%80%91%E9%80%9A%E7%81%B5.png',
      },
      {
        title: '【口碑】Emma',
        url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%8F%A3%E7%A2%91%E3%80%91Emma.png',
      },
      {
        title: '【人选会面记录】高兴',
        type: 'word',
        md5: 'b11153efacb3e7d9b96ea8628526d676',
      },
      {
        title: '【人选会面记录】诗云',
        type: 'word',
        md5: '47299727683e9965ec859ab075f6c030',
      },
      {
        title: '【人选会面记录】Emma1',
        type: 'word',
        md5: '7d181a9d35717b014be5669a6a603b92',
      },
      {
        title: '【人选会面记录】Emma2',
        type: 'word',
        md5: '604834cd61394313865ec526ca939b08',
      },
    ],
  },
  '6': {
    视频: [
      {
        title: '1.Mapping的目的.mp4',
        url: 'https://vod.aconsulting.top/sv/1ef10054-179a19ea99d/1ef10054-179a19ea99d.mp4',
      },
      {
        title: '2.前端&后端配合模式.mp4',
        url: 'https://vod.aconsulting.top/sv/39e428da-179a19ea9ba/39e428da-179a19ea9ba.mp4',
      },
      {
        title: '3.Mapping入门.mp4',
        url: 'https://vod.aconsulting.top/sv/35a02b5e-179a19ea9ce/35a02b5e-179a19ea9ce.mp4',
      },
      {
        title: '4.Mapping演练.mp4',
        url: 'https://vod.aconsulting.top/sv/3a415361-179a19ea9e8/3a415361-179a19ea9e8.mp4',
      },
      {
        title: '5.内线培养及阿尔法mapping秘籍.mp4',
        url: 'https://vod.aconsulting.top/sv/4a1e5761-179a19eaa03/4a1e5761-179a19eaa03.mp4',
      },
    ],
  },
  '7': {
    教学目的: [
      {
        title: '【教学目的】如何拿通讯录.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E5%A6%82%E4%BD%95%E6%8B%BF%E9%80%9A%E8%AE%AF%E5%BD%95.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】如何获取list.mp4',
        url: 'https://vod.aconsulting.top/sv/20c30f20-1751c44346c/20c30f20-1751c44346c.mp4',
      },
    ],
    附件: [
      {
        title: '如何要通讯录.png',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%A6%82%E4%BD%95%E8%A6%81%E9%80%9A%E8%AE%AF%E5%BD%95.png',
      },
      {
        title: '如何要list.docx',
        type: 'word',
        md5: '6a1794156e2147578982b77c6a344023',
      },
    ],
  },
  '8': {
    教学目的: [
      {
        title: '【教学目的】面试安排&面试辅导.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】面试辅导和安排.mp4',
        url: 'https://vod.aconsulting.top/sv/4de7beb1-1751f868337/4de7beb1-1751f868337.mp4',
      },
      {
        title: '【教学视频】如何安排傲娇候选人面试.mp4',
        url: 'https://vod.aconsulting.top/sv/4de7613b-1751f868356/4de7613b-1751f868356.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】面试辅导.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC.pdf',
      },
      {
        title: '【操作手册】如何安排傲娇候选人面试.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E5%A6%82%E4%BD%95%E5%AE%89%E6%8E%92%E5%82%B2%E5%A8%87%E5%80%99%E9%80%89%E4%BA%BA%E9%9D%A2%E8%AF%95.pdf',
      },
      {
        title: '【模版】面试安排.doc',
        type: 'word',
        md5: 'fe21f22125dd94a5053ee9ce8cd4b92d',
      },
      {
        title: '【思维导图】如何安排傲娇人选面试.png',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E3%80%91%E5%A6%82%E4%BD%95%E5%AE%89%E6%8E%92%E5%82%B2%E5%A8%87%E4%BA%BA%E9%80%89%E9%9D%A2%E8%AF%95.png',
      },
    ],
  },
  '9': {
    教学目的: [
      {
        title: '【教学目的】面试反馈. jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E9%9D%A2%E8%AF%95%E5%8F%8D%E9%A6%88.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】面试反馈.mp4',
        url: 'https://vod.aconsulting.top/sv/4fe04610-1751f86833b/4fe04610-1751f86833b.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】面试反馈.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%9D%A2%E8%AF%95%E5%8F%8D%E9%A6%88.pdf',
      },
      {
        title: '【模版】面试反馈.docx',
        type: 'word',
        md5: '228e06a9ca7fa85b0690d2f331583838',
      },
      {
        title: '【示例】面试反馈.docx',
        type: 'word',
        md5: 'e8ecda325b026becce04bb8ab588ac43',
      },
    ],
  },
  '10': {
    教学目的: [
      {
        title: '【教学目的】项目搜索报告&人才mapping报告.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E9%A1%B9%E7%9B%AE%E6%90%9C%E7%B4%A2%E6%8A%A5%E5%91%8A%26%E4%BA%BA%E6%89%8Dmapping%E6%8A%A5%E5%91%8A.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】项目搜索报告&人才mapping报告.mp4',
        url: 'https://vod.aconsulting.top/sv/360f8b29-1751fc7c4fd/360f8b29-1751fc7c4fd.mp4',
      },
    ],
    附件: [
      {
        title: '【范例】资产管理部-权益投资岗-项目搜索进度报告.xlsx',
        type: 'word',
        md5: 'c1188d2ef619dfced98e08890cdfd9be',
      },
      {
        title: '【范例】mapping报告-指数增强优质人选表-阿尔法咨询.xlsx',
        type: 'word',
        md5: '52419f5ce0b90bcf725cf41622ff82cf',
      },
      {
        title: '【范例】市场小结-佳哥',
        type: 'word',
        md5: 'b6dd65bc1aa45a8bf32755a3df9d14c5',
      },
      {
        title: '【项目搜索报告】Emma-债券投资经理',
        type: 'word',
        md5: '0a6bbe2453dc783872c7bab95dc0890',
      },
      {
        title: '【项目搜索报告】Emma-xx证券资管-CTO',
        type: 'word',
        md5: 'da9d057901321d20dd18b6efd8cb55a7',
      },
      {
        title: '【项目搜索报告】Eric',
        type: 'word',
        md5: '96833a5aa5a9615683a4ad287fc0a917',
      },
    ],
  },
  '11': {
    教学目的: [
      {
        title: '【教学目的】背景调查.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E8%83%8C%E6%99%AF%E8%B0%83%E6%9F%A5.jpg',
      },
    ],
    视频: [
      {
        title: '【视频教学】背景调查.mp4',
        url: 'https://vod.aconsulting.top/sv/428f6b1b-1751fc7c503/428f6b1b-1751fc7c503.mp4',
      },
    ],
    音频: [
      {
        title: '【示例】offer谈判withZO基金赵xx.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E7%A4%BA%E4%BE%8B%E3%80%91offer%E8%B0%88%E5%88%A4withZO%E5%9F%BA%E9%87%91%E8%B5%B5XX.mp3',
      },
      {
        title: '【沟通】Cathy-Push&Pull-猎头的本质是思考.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%B2%9F%E9%80%9A%E3%80%91Cathy-Push%26Pull-%E7%8C%8E%E5%A4%B4%E7%9A%84%E6%9C%AC%E8%B4%A8%E6%98%AF%E6%80%9D%E8%80%83-%E9%9F%B3%E9%A2%91%20.mp3',
      },
    ],
    附件: [
      {
        title: '【操作手册】背景调查.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E8%83%8C%E6%99%AF%E8%B0%83%E6%9F%A5.pdf',
      },
      {
        title: '【范例】阿尔法咨询-xx-背景调查.doc',
        type: 'word',
        md5: '86852840802c23875da7a0d0697e7b6a',
      },
      {
        title: '【沟通】Cathy-Push&Pull-猎头的本质是思考.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%B2%9F%E9%80%9A%E3%80%91Cathy-Push%26Pull-%E7%8C%8E%E5%A4%B4%E7%9A%84%E6%9C%AC%E8%B4%A8%E6%98%AF%E6%80%9D%E8%80%83%20.pdf',
      },
      {
        title: '【模版】背景调查报告.doc',
        type: 'word',
        md5: '4897bb93dd3a9dbb7b5e00b48bfe85a9',
      },
      {
        title: '【模版】承诺书.doc',
        type: 'word',
        md5: '172a258a14c483cdf4cd1ec0314cfbc7',
      },
      {
        title: '如何谈薪.pdf',
        url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%A6%82%E4%BD%95%E8%B0%88%E8%96%AA.pdf',
      },
      {
        title: 'offer谈判HT  FICCcase复盘--如何让客户加薪.docx',
        type: 'word',
        md5: '0b0012b80d9c9c56676a91fae9361fb1',
      },
      {
        title: '【背景报告】奕奕',
        type: 'word',
        md5: 'd47d0413034b14a4d4891e0053c9ca76',
      },
      {
        title: '【背景报告】Emma',
        type: 'word',
        md5: 'c6b066e8dfe8ec27fc8c3d087fc5af92',
      },
      {
        title: '【offer谈判】东东',
        type: 'word',
        md5: '47018f14cc5381747b3926c60c39ab11',
      },
      {
        title: '【offer谈判】高兴',
        type: 'word',
        md5: '20521dbd9f662d722a83baad06dcc836',
      },
      {
        title: '【offer谈判】诗云-港股候选人',
        type: 'word',
        md5: '123ff9515c9907916fbcb40e2932c697',
      },
      {
        title: '【offer谈判】Emma',
        type: 'word',
        md5: '619bbba3036d29aeb44a4140fcb7490f',
      },
    ],
  },
  '12': {
    教学目的: [
      {
        title: '【教学目的】离职辅导.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E7%A6%BB%E8%81%8C%E8%BE%85%E5%AF%BC.jpg',
      },
    ],
    视频: [
      {
        title: '【视频教学】离职辅导.mp4',
        url: 'https://vod.aconsulting.top/sv/1cb9e700-1751f86d7f6/1cb9e700-1751f86d7f6.mp4',
      },
    ],
    音频: [
      {
        title: '【示例】xx年金债券投资xxx.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E7%A4%BA%E4%BE%8B%E3%80%91XX%E5%B9%B4%E9%87%91%E5%80%BA%E5%88%B8%E6%8A%95%E8%B5%84XXX.mp3',
      },
      {
        title: '【离职辅导】Emma2.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E7%A6%BB%E8%81%8C%E8%BE%85%E5%AF%BC%E3%80%91Emma2.mp3',
      },
    ],
    附件: [
      {
        title: '【操作手册】离职辅导.pdf',
        url: '',
      },
      {
        title: '【模版】离职辅导话术.doc',
        type: 'word',
        md5: '361e5cddc26c285765818c1fe7c5f93a',
      },
      {
        title: '【离职辅导】东东',
        type: 'word',
        md5: '708737e44ee7863b886e8c00b431a6d7',
      },
      {
        title: '【离职辅导】诗云',
        type: 'word',
        md5: '784359aa64720df5fd1a9d22ad69d7fa',
      },
      {
        title: '【离职辅导】雪哥',
        type: 'word',
        md5: '07837155eae0ee193e5f34c3da88f88d',
      },
    ],
  },
  '13': {
    音频: [
      {
        title: '维护客户小技巧-Cathy.mp3',
        url: 'https://vod.aconsulting.top/sv/436c1315-179a20b7b80/436c1315-179a20b7b80.mp4',
      },
    ],
  },
  '16': {
    视频: [
      {
        title: '【教学视频】高效能顾问的节奏和时间安排.mp4',
        url: 'https://vod.aconsulting.top/sv/5e3fbee7-1751ad17576/5e3fbee7-1751ad17576.mp4',
      },
      {
        title: '【教学视频】猎头行规&那些不能踩的坑.mp4',
        url: 'https://vod.aconsulting.top/sv/517ff6ba-1751ad175de/517ff6ba-1751ad175de.mp4',
      },
      {
        title: '1.金融科普，小白特供.mp4',
        url: 'https://vod.aconsulting.top/sv/dd639aa-179a20ec636/dd639aa-179a20ec636.mp4',
      },
      {
        title: '2.VC PE IPO 以及证监会爸爸.mp4',
        url: 'https://vod.aconsulting.top/sv/546bb4fd-179a20ec6a4/546bb4fd-179a20ec6a4.mp4',
      },
      {
        title: '3.投行和保代，高大上，有木有.mp4',
        url: 'https://vod.aconsulting.top/sv/49893aff-179a21109bf/49893aff-179a21109bf.mp4',
      },
      {
        title: '4.二级市场的玩法.mp4',
        url: 'https://vod.aconsulting.top/sv/434afe51-179a2111d47/434afe51-179a2111d47.mp4',
      },
      {
        title: '5.基金公司就像个配菜师傅.mp4',
        url: 'https://vod.aconsulting.top/sv/79eeb6-179a2113395/79eeb6-179a2113395.mp4',
      },
      {
        title: '6.证券公司里的资管部门，换汤不换药.mp4',
        url: 'https://vod.aconsulting.top/sv/2e7a0f15-179a2135c64/2e7a0f15-179a2135c64.mp4',
      },
      {
        title: '7.债（固定收益）.mp4',
        url: 'https://vod.aconsulting.top/sv/38a1e20-179a213660b/38a1e20-179a213660b.mp4',
      },
      {
        title: '8.课程回顾.mp4',
        url: 'https://vod.aconsulting.top/sv/2c0df77d-179a2136a9a/2c0df77d-179a2136a9a.mp4',
      },
      {
        title: '1.职位分析.mp4',
        url: 'https://vod.aconsulting.top/sv/2792214f-179a20ec655/2792214f-179a20ec655.mp4',
      },
      {
        title: '2.电话沟通.mp4',
        url: 'https://vod.aconsulting.top/sv/1626c70f-179a20ec676/1626c70f-179a20ec676.mp4',
      },
      {
        title: '3.索要简历&推荐.mp4',
        url: 'https://vod.aconsulting.top/sv/4ac486d8-179a20ec6c5/4ac486d8-179a20ec6c5.mp4',
      },
      {
        title: '4.安排面试.mp4',
        url: 'https://vod.aconsulting.top/sv/39f15556-179a2111ba5/39f15556-179a2111ba5.mp4',
      },
      {
        title: '5.谈offer&跟进离职和到岗.mp4',
        url: 'https://vod.aconsulting.top/sv/60200596-179a21319e2/60200596-179a21319e2.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】高效能顾问的工作节奏和时间分配.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%AB%98%E6%95%88%E8%83%BD%E9%A1%BE%E9%97%AE%E7%9A%84%E5%B7%A5%E4%BD%9C%E8%8A%82%E5%A5%8F%E5%92%8C%E6%97%B6%E9%97%B4%E5%88%86%E9%85%8D.pdf',
      },
      {
        title: '工作台功能使用教程',
        type: 'word',
        md5: '4fd57b8443bc46740cc1787d96ea91ee',
      },
    ],
  },
  '17': {
    教学目的: [
      {
        title: '【教学目的】筛选简历. jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E7%AD%9B%E9%80%89%E7%AE%80%E5%8E%86.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】筛选简历.mp4',
        url: 'https://vod.aconsulting.top/sv/8420325-1751b415058/8420325-1751b415058.mp4',
      },
      {
        title: '【教学视频】人才搜索.mp4',
        url: 'https://vod.aconsulting.top/sv/5c3550ed-1751fd949da/5c3550ed-1751fd949da.mp4',
      },
    ],
    附件: [
      {
        title: '【操作导图】筛选简历.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%9B%BE%E3%80%91%E7%AD%9B%E9%80%89%E7%AE%80%E5%8E%86.jpg',
      },
      {
        title: '人才搜索功能使用教程',
        type: 'word',
        md5: 'c9888b156864fa1e2a44921918a07a1f',
      },
    ],
  },
  '18': {
    附件: [
      {
        title: '操作手册-KPI、业绩、体系化积分',
        type: 'word',
        md5: '6843d1a6f09c205ef84fec91474808da',
      },
    ],
  },
  '19': {
    附件: [
      {
        title: '快搜搜索功能使用教程',
        type: 'word',
        md5: 'e7d585c65ca8c162ab24d1bad38cd96a',
      },
    ],
  },
  '20': {
    附件: [
      {
        title: '猎聘搜索功能使用教程',
        type: 'word',
        md5: 'a0c01955270cf5fbce258f7052c8ab3f',
      },
    ],
  },
  '21': {
    附件: [
      {
        title: '人才流动统计功能使用教程',
        type: 'word',
        md5: '749af75f34033a68467e2d7f75688198',
      },
    ],
  },
  '22': {
    附件: [
      {
        title: '市场资讯功能使用教程',
        type: 'word',
        md5: '2cc24c0b9e89a1a1fe7ddd22cfc227c8',
      },
    ],
  },
  '23': {
    附件: [
      {
        title: '推荐历史功能使用教程',
        type: 'word',
        md5: '6b80054c4a3ca012f4770a1b98d0757d',
      },
    ],
  },
  '24': {
    音频: [
      {
        title: '问薪酬实操课程1-语气自然，立场坚定.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B1-%E8%AF%AD%E6%B0%94%E8%87%AA%E7%84%B6%EF%BC%8C%E7%AB%8B%E5%9C%BA%E5%9D%9A%E5%AE%9A.mp3',
      },
      {
        title: '问薪酬实操课程2-反守为攻.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B2-%E5%8F%8D%E5%AE%88%E4%B8%BA%E6%94%BB.mp3',
      },
      {
        title: '问薪酬实操课程3-建立信任.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B3-%E5%BB%BA%E7%AB%8B%E4%BF%A1%E4%BB%BB.mp3',
      },
      {
        title: '问薪酬实操课程4-沟通技巧（1）.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B4-%E6%B2%9F%E9%80%9A%E6%8A%80%E5%B7%A7%EF%BC%881%EF%BC%89.mp3',
      },
      {
        title: '问薪酬实操课程5-沟通技巧（2）.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B5-%E6%B2%9F%E9%80%9A%E6%8A%80%E5%B7%A7%EF%BC%882%EF%BC%89.mp3',
      },
      {
        title: '问薪酬实操课程6-乘胜追击-薪酬结构.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B6-%E4%B9%98%E8%83%9C%E8%BF%BD%E5%87%BB-%E8%96%AA%E9%85%AC%E7%BB%93%E6%9E%84.mp3',
      },
      {
        title: '问薪酬实操课程7-乘胜追击-激励与考核.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B7-%E4%B9%98%E8%83%9C%E8%BF%BD%E5%87%BB-%E6%BF%80%E5%8A%B1%E4%B8%8E%E8%80%83%E6%A0%B8.mp3',
      },
      {
        title: '问薪酬实操课程8-乘胜追击-刺激.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B8-%E4%B9%98%E8%83%9C%E8%BF%BD%E5%87%BB-%E5%88%BA%E6%BF%80.mp3',
      },
      {
        title: '问薪酬实操课程9-乘胜追击-薪酬制度.mp3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%97%AE%E8%96%AA%E9%85%AC%E5%AE%9E%E6%93%8D%E8%AF%BE%E7%A8%8B9-%E4%B9%98%E8%83%9C%E8%BF%BD%E5%87%BB-%E8%96%AA%E9%85%AC%E5%88%B6%E5%BA%A6.mp3',
      },
    ],
  },
  '25': {
    教学目的: [
      {
        title: '【教学目的】面试安排&面试辅导.jpg',
        type: 'img',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%95%99%E5%AD%A6%E7%9B%AE%E7%9A%84%E3%80%91%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC.jpg',
      },
    ],
    视频: [
      {
        title: '【教学视频】面试辅导和安排.mp4',
        url: 'https://vod.aconsulting.top/sv/4de7beb1-1751f868337/4de7beb1-1751f868337.mp4',
      },
    ],
    附件: [
      {
        title: '【操作手册】面试辅导.pdf',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC.pdf',
      },
      {
        title: '【面试安排&面试辅导】雪哥',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91%E9%9B%AA%E5%93%A5.jpg',
      },
      {
        title: '【面试安排&面试辅导】雪哥2',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91%E9%9B%AA%E5%93%A52.png',
      },
      {
        title: '【面试安排&面试辅导】雪哥3',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91%E9%9B%AA%E5%93%A53.png',
      },
      {
        title: '【面试安排&面试辅导】雪哥4',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91%E9%9B%AA%E5%93%A54.jpg',
      },
      {
        title: '【面试安排&面试辅导】Emma',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91Emma.png',
      },
      {
        title: '【面试安排&面试辅导】Emma2',
        url:
          'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E9%9D%A2%E8%AF%95%E5%AE%89%E6%8E%92%26%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC%E3%80%91Emma2.jpg',
      },
    ],
  },
  '26': {
    附件: [
      {
        title: '【范例】某区域债券市场人才搜寻报告 0621.docx',
        type: 'word',
        md5: 'a7c69e9215bb4d3285c06e9a3defcf8c',
      },
      {
        title: '【范例】股票投资岗位-项目搜索进度报告.xlsx',
        type: 'word',
        md5: '66b1ea5dcb49816ceabc93dfde3000a0',
      },
      {
        title: '【项目搜索进度报告模板】筹备券商版.xls',
        type: 'word',
        md5: 'eb5d38a77a07210a940be6a7759cc4a6',
      },
    ],
  },
}
export default peixunData
